import React from "react";
import Cell from "./Cell";
import Checkbox from "../input/Checkbox";
import { LuChevronDown, LuChevronUp } from "react-icons/lu";
import { getRowData } from "../../functions/Data";
import RadioButton from "../input/RadioButton";
import { GroupedPaymentList, PaymentDetail } from "../../types-interfaces/interfaces";

interface RowProps extends React.HTMLAttributes<HTMLElement>{  
  rowData: PaymentDetail
  isGrouped?: boolean | undefined
  isDetail?: boolean | undefined
  showDetail?: boolean | undefined
  onClickDetail?: React.MouseEventHandler<HTMLButtonElement> | undefined
  onCheck?: (item: PaymentDetail | GroupedPaymentList, evt: React.MouseEvent<HTMLInputElement, MouseEvent>, isDetail: boolean | undefined, index:number, paymentCount: number) => void | undefined  
  checkAll?: boolean | undefined
  index: number
  selectionType?: "single" | "multiple" | undefined
  uncheck?: string | undefined
  checked: boolean
  paymentCount: number
}

interface RowState{
  checked: boolean  
}

class RowPayment extends React.Component<RowProps, RowState> {
  state = {checked: false, checkedAll: false}
  currency = "";

  componentDidUpdate(prevProps: Readonly<RowProps>): void {
    if (this.props.checkAll !== undefined && prevProps.checkAll !== this.props.checkAll && this.props.isDetail){
      this.setState({ checked: this.props.checkAll});
    }

    if (this.props.uncheck !== undefined && prevProps.uncheck !== this.props.uncheck && this.props.selectionType === "single"){
      this.setState({checked: false});
    }
  }

  componentDidMount(): void {
    if (this.props.checkAll !== undefined && this.props.isDetail){
      this.setState({ checked: this.props.checkAll})
    }
  }

  getCurrency(colName:string, colValue:string): string {    
    let currency = "";
    if(colName === "currencyType"){
      this.currency = colValue;      
    } else if (colName === "total" || colName === "amount" || colName === "amountPayed"){
      currency = this.currency;
    } else {
      return "";
    }   
    return currency;
  }

  render() {
    return (     
      <div className={this.props.className}>
        {getRowData(this.props.rowData, this.props.isGrouped, this.props.isDetail)?.map((cell,index) =>        
          <Cell          
            key={'c' + index}
            className={this.props.className + '-cell'}
            currency={this.getCurrency(cell.colName,cell.colValue)}
            value={cell.colValue}
            columnname={cell.colName}
          >{ (
              ((index === 0 || index === 1) && this.props.isGrouped) ||
              (index === 0 && this.props.isDetail) ||
              (this.props.selectionType === "single") ||
              (this.props.selectionType === "multiple")
              ) &&
            <div
              style={{
                display:"flex",
                flexDirection:"row",
                gap:"16px",
                width:"50px",
                alignItems:"center",
                alignSelf:"stretch",
              }}
            >
              { (this.props.isGrouped || this.props.isDetail || this.props.selectionType === "multiple") && index === 0  &&
                <Checkbox
                  className="checkbox-payment"
                  onClick={(evt) => {this.props.onCheck && this.props.onCheck(this.props.rowData, evt, this.props.isDetail, (this.props.isGrouped? index : this.props.index), this.props.paymentCount)}}
                  onChange={() => this.setState({checked: !this.state.checked})}
                  checked={this.props.checked}
                />
              }
              { this.props.selectionType === "single" && index === 0 &&
              <RadioButton
                onClick={(evt) => {this.props.onCheck && this.props.onCheck(this.props.rowData, evt, this.props.isDetail, (this.props.isGrouped? index : this.props.index), this.props.paymentCount)}}
                onChange={() => this.setState({checked: !this.state.checked})}
                checked={this.state.checked}
              />
              }
              { this.props.isGrouped && index === 1 &&
                <button
                  style={{                    
                    width:"24px",
                    height:"24px",                    
                    backgroundColor:"transparent",
                    alignSelf:"stretch",
                    border:"0px"
                  }}
                  onClick={this.props.onClickDetail}
                  data-testid={"show-detail-button-" + this.props.index}
                >
                  { this.props.showDetail ?
                    <LuChevronUp
                      style={{
                        flex:"1 0 0",
                        alignSelf:"stretch",
                        width:"24px",
                        height:"24px",
                        color:"#0061A0"
                      }}
                    />
                    :
                    <LuChevronDown
                      style={{
                        flex:"1 0 0",
                        alignSelf:"stretch",
                        width:"24px",
                        height:"24px",
                        color:"#0061A0"
                      }}
                    />
                  }                  
                </button>                
              }
            </div>
            }
          </Cell>
        )}
      </div>     
    );
  }
  
}

export default RowPayment;

